export const fetchContractList = ({
  templateId,
  page,
  perPage,
  search
}) => {   
  let url = `/contracts`;

  if (templateId) {
    url = `/templates/${templateId}/contracts`;
  }

  return ({
    method: 'GET',
    endpoint: `${url}?page=${page}&perPage=${perPage}&search=${search}`
  })
};

export const fetchContract = (contractId) => ({
  method: 'GET',
  endpoint: `/contracts/${contractId}`,
});

export const fetchIncomingContractList = ({
  page,
  perPage,
  search
}) => ({
  method: 'GET',
  endpoint: `/incoming-contracts?page=${page}&perPage=${perPage}&search=${search}`,
});

export const saveContract = (values) => { 
  let url = `/contract/save/${values._id}`;
  if (!values._id) {
    url = '/contract/create';
  }

  return ({
    method: 'POST',
    endpoint: url,
    headers: {
      'Content-Type': 'application/json',
    },
    body: values
  })
}

export const createContract = ({templateId, ...values}) => { 
  // let url = `/contract/save/${values._id}`;
  // if (!values._id) {
  let url = '/contracts';
  if (templateId) {
    url = `/templates/${templateId}/contracts`;
  }
  // }

  return ({
    method: 'POST',
    endpoint: url,
    headers: {
      'Content-Type': 'application/json',
    },
    body: values
  })
}

export const createTestament = ({templateId, ...values}) => { 
  return ({
    method: 'POST',
    endpoint:`/templates/${templateId}/testaments`,
    headers: {
      'Content-Type': 'application/json',
    },
    body: values
  })
}

export const convertContractTo = ({contractId, ...values}) => {
  return ({
    method: 'POST',
    endpoint: `/contracts/${contractId}/convert`,
    headers: {
      'Content-Type': 'application/json',
    },
    body: values
  })
}


export const sendContract = (values) => ({
  method: 'POST',
  endpoint: `/contract/send/${values._id}`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})

export const resendContract = (values) => ({
  method: 'POST',
  endpoint: `/notifications/email/${values.contractId}/${values.participantId}/participants`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const contractAction = (contractId, action, body) => {
  return ({
    method: 'POST',
    endpoint: `/ncontracts/${contractId}/${action}`,
    prefix: ' ',
    body
  });
}